import { useContext } from "react";

import { AlertBannerContext } from "./AlertBannerContext";

export const useAlertBannerHeight = () => {
  return useContext(AlertBannerContext).bannerHeightPx;
};

export const useAlertBannerRef = () => {
  return useContext(AlertBannerContext).bannerRef;
};
